var fxTopo = {};

fxTopo.jaVerify = false;

fxTopo.vefiry = function () {
	if(midiaSize == 'xl' || midiaSize == 'lg'){
		var menuFuncionalidades = $('.menu-funcionalidades');

		if(menuFuncionalidades.length > 0){
			$('.topo').addClass('has-menu-funcionalidades');
		}

		if($(window).scrollTop() >= $('.topo').outerHeight()){
			$('.topo').css('height', $('.topo').outerHeight());

			$('.topo').addClass('fx-topo')
		}else{
			$('.topo').removeAttr('style');

			$('.topo').removeClass('fx-topo')
		}
	}
};

fxTopo.start = (function(){
	var verify = fxTopo.vefiry;

	verify();

	$(window).scroll(function(){
		if(fxTopo.jaVerify) return;

		setTimeout(function(){
			fxTopo.jaVerify = false
		}, 100)

		verify()
	});
})();